import es from './es-MX'
import pt from './pt-BR'
import en from './en-US'
export default {
  'pt-BR': pt,
  'en-US': en,
  'es-MX': es
}
